import React from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Intro } from "../components/Intro";
import { Partners } from "../components/Partners";
import { Needs } from "../components/Needs";
import { Placements } from "../components/Placements";
import { Management } from "../components/Management";
import { RealEstate } from "../components/RealEstate";
import { ContactCta } from "../components/ContactCta";
import { Footer } from "../components/Footer";
export function Home() {
  return <div className="min-h-screen w-full bg-white" data-id="element-207" data-mp="24hk6xchgnhkb">
      <Header data-id="element-208" data-mp="29gdekoa2geck" />
      <main data-id="element-209" data-mp="29fvgrn7r9s2j">
        <Hero data-id="element-210" data-mp="29fbzm8pxj7pk" />
        <Intro data-id="element-211" data-mp="29ek6d4jt1m2g" />
        <Partners data-id="element-212" data-mp="29i7z41hfe4g4" />
        <Needs data-id="element-213" data-mp="2dhqj8v1fabhw" />
        <Placements data-id="element-214" data-mp="2di8crjwpabm4" />
        <Management data-id="element-215" data-mp="2dirxt9hndg4d" />
        <RealEstate data-id="element-216" data-mp="2dj1mmtqyhh8h" />
        <ContactCta data-id="element-217" data-mp="2dfdspthlmst8" />
      </main>
      <Footer data-id="element-218" data-mp="3kvtp1ov40a2p" />
    </div>;
}